/** 系統代碼列舉 */
export enum SystemCodeEnum {
    /** 機構類型(診所、醫院、藥局) */
    A0010 = 10010,
    /** 職務類別 */
    A0020 = 10020,
    /** 假期分類 */
    A0030 = 10030,
    /** 工作站別 */
    A0040 = 10040,
    /** 專業角色 */
    A0050 = 10050,
    /** 醫事人員別 */
    A0060 = 10060,
    /** 專科別 */
    A0070 = 10070,
    /** 國別代碼 */
    B0010 = 20010,
    /** 人種/民族 */
    B0020 = 20020,
    /** 職業代碼 */
    B0030 = 20030,
    /** 教育程度 */
    B0040 = 20040,
    /**  */
    B0050 = 20050,
    /** RH型別 */
    B0051 = 20051,
    /** 關系人類型(緊急連絡人) */
    B0060 = 20060,
    /** 提供者關係人類型 */
    B0061 = 20061,
    /** 婚姻 */
    B0080 = 20080,
    /** 個案來源類別 */
    B0090 = 20090,
    /** 個案來源項目 */
    B0091 = 20091,
    /** 身分別 */
    B0100 = 20100,
    /** 慣用語言 */
    B0110 = 20110,
    /** 保險資料 */
    B0120 = 20120,
    /** 經濟來源 */
    B0130 = 20130,
    /** 照護方式 */
    B0140 = 20140,
    /** 健康狀況預後 */
    B0150 = 20150,
    /** 日常休閒 */
    B0160 = 20160,
    /** 收案原因 */
    B0170 = 20170,
    /** 照護團隊 */
    B0175 = 20175,
    /** 指導項目 */
    B0180 = 20180,
    /** 結案原因 */
    B0190 = 20190,
    /** 區 */
    B0200 = 20200,
    /** 稱謂 */
    B0210 = 20210,
    /** 合約類型 */
    B0220 = 20220,
    /** 合約狀態 */
    B0230 = 20230,
    /** 照護等級 */
    B0240 = 20240,
    /** 支付方式 */
    B0250 = 20250,
    /** 個案身分類別 */
    B0260 = 20260,
    /** 保險身分 */
    C0010 = 30010,
    /** 就醫科別 */
    C0020 = 30020,
    /** 同療類型 */
    C0030 = 30030,
    /** 牙科類型 */
    C0031 = 30031,
    /** 同療類型(中醫) */
    C0032 = 30032,
    /** 就診狀態(候診…) */
    C0040 = 30040,
    /** 申報案類 */
    C0050 = 30050,
    /** 處置類型 */
    C0060 = 30060,
    /** 調劑類別 */
    C0070 = 30070,
    /** 勞職 */
    C0080 = 30080,
    /** 給類 */
    C0090 = 30090,
    /** 藥品單位 */
    C0100 = 30100,
    /** 服法 */
    C0110 = 30110,
    /** 診間定義 */
    C0120 = 30120,
    /** 病歷狀態 */
    C0130 = 30130,
    /** 訪視類型(初複診) */
    C0140 = 30140,
    /** 掛號來源(現預網) */
    C0150 = 30150,
    /** 途徑 */
    C0160 = 30160,
    /** 醫院 */
    C0170 = 30170,
    /** 醫師 */
    C0172 = 30172,
    /** 住院原因 */
    C0175 = 30175,
    /** 藥物類別 */
    C0180 = 30180,
    /** 檢驗類別 */
    C0190 = 30190,
    /** 部位 */
    C0200 = 30200,
    /** 劑型 */
    C0210 = 30210,
    /** 醫令備註 */
    C0220 = 30220,
    /**  */
    C0230 = 30230,
    /** 中藥處理方式 */
    C0300 = 30300,
    /** 中醫-望診 */
    C0310 = 30310,
    /** 中醫-問診 */
    C0320 = 30320,
    /** 中醫-脈診 */
    C0330 = 30330,
    /** 中醫-辨證 */
    C0340 = 30340,
    /** 中醫-治則 */
    C0350 = 30350,
    /** 中醫-製劑 */
    C0360 = 30360,
    /** 中醫-療效 */
    C0361 = 30361,
    /** 中醫-醫囑 */
    C0370 = 30370,
    /** 中醫-處理備註 */
    C0392 = 30392,
    /** 遠距會診診間 */
    C0410 = 30410,
    /** 復健活動 */
    D0010 = 40010,
    /** 日常生活訓練 */
    D0020 = 40020,
    /** 活動安排 */
    D0030 = 40030,
    /** 清潔記錄 */
    D0040 = 40040,
    /** 類型 */
    D0050 = 40050,
    /** 其他 */
    D0060 = 40060,
    /** 個案營養狀況及現存問題 */
    D0070 = 40070,
    /** 營養師評估及建議 */
    D0080 = 40080,
    /** 家屬的反應及處理 */
    D0090 = 40090,
    /** 護理人員的執行及家屬告知 */
    D0100 = 40100,
    /** 主照者評估-睡眠 */
    D0110 = 40110,
    /** 主照者評估-情緒 */
    D0111 = 40111,
    /** 主照者評估-壓力 */
    D0112 = 40112,
    /** 主照者評估-疲憊度 */
    D0113 = 40113,
    /** 排便輔助方式-頻率 */
    D0120 = 40120,
    /** 活動型態 */
    D0130 = 40130,
    /** 行動輔助 */
    D0140 = 40140,
    /** 轉介單-服務需求 */
    D0150 = 40150,
    /** 轉介單-轉介單位 */
    D0160 = 40160,
    /** 轉介單-轉介處置 */
    D0170 = 40170,
    /** 共用 */
    E0010 = 50010,
    /** 主訴 */
    E0020 = 50020,
    /** 理學 */
    E0030 = 50030,
    /** 醫囑 */
    E0040 = 50040,
    /** 既往病史 */
    E0050 = 50050,
    /** 家族病史 */
    E0060 = 50060,
    /** 手術病史 */
    E0070 = 50070,
    /** 過敏史(食物、環境) */
    E0080 = 50080,
    /** 重大傷病史 */
    E0090 = 50090,
    /** 傳染病史 */
    E0100 = 50100,
    /** 不良產科史 */
    E0110 = 50110,
    /** 藥物不良反應 */
    E0120 = 50120,
    /** 住院計畫 */
    E0130 = 50130,
    /** 入院診斷 */
    E0140 = 50140,
    /** 出院治療計畫 */
    E0150 = 50150,
    /** 特記 */
    E0190 = 50190,
    /** 費用科目 */
    F0010 = 60010,
    /** 計價來源(掛號、看診、銷售…) */
    F0020 = 60020,
    /** 付款方式(現金、行動支付、信用卡…) */
    F0030 = 60030,
    /** 公告類別 */
    G0020 = 70020,
    /** 常規類別 */
    G0030 = 70030,
    /** 管路更換天數 */
    G0040 = 70040,
    /** 藥品單位 */
    H0010 = 80010,
    /** 進貨單位 */
    H0020 = 80020,
    /** 庫存異動類型 */
    H0030 = 80030,
    /** 進貨單位 */
    H0040 = 80040,
    /** 庫存調整備註 */
    H0050 = 80050,
    /** 病床別 */
    I0010 = 90010,
    /** 區域 */
    I0020 = 90020,
    /** 房型 */
    I0030 = 90030,
    /** 病歷類型 */
    J0010 = 100010,
    /** 檢驗結果類型 */
    K0010 = 110010,
    /** 檢驗外送單位 */
    K0020 = 110020,
    /** 系統公告類型 */
    S0110 = 190110,
    /** 系統參數類型 */
    S0120 = 190120,
    /** 本地報表類型 */
    S0130 = 190130,
    /** 系統取號重複方式 */
    S0140 = 190140,
    /** 系統取號規格代碼 */
    S0150 = 190150,
    /** 公告分類 */
    S0160 = 190160
}
export const SystemCodeDesc: {text: string, value: number}[] =
    [{text: '機構類型', value: 10010 },
     {text: '職務類別', value: 10020 },
     {text: '假期分類', value: 10030 },
     {text: '工作站別', value: 10040 },
     {text: '專業角色', value: 10050 },
     {text: '醫事人員別', value: 10060 },
     {text: '專科別', value: 10070 },
     {text: '國別代碼', value: 20010 },
     {text: '人種/民族', value: 20020 },
     {text: '職業代碼', value: 20030 },
     {text: '教育程度', value: 20040 },
     {text: '血型', value: 20050 },
     {text: 'RH型別', value: 20051 },
     {text: '關系人類型', value: 20060 },
     {text: '提供者關係人類型', value: 20061 },
     {text: '婚姻', value: 20080 },
     {text: '個案來源類別', value: 20090 },
     {text: '個案來源項目', value: 20091 },
     {text: '身分別', value: 20100 },
     {text: '慣用語言', value: 20110 },
     {text: '保險資料', value: 20120 },
     {text: '經濟來源', value: 20130 },
     {text: '照護方式', value: 20140 },
     {text: '健康狀況預後', value: 20150 },
     {text: '日常休閒', value: 20160 },
     {text: '收案原因', value: 20170 },
     {text: '照護團隊', value: 20175 },
     {text: '指導項目', value: 20180 },
     {text: '結案原因', value: 20190 },
     {text: '區', value: 20200 },
     {text: '稱謂', value: 20210 },
     {text: '合約類型', value: 20220 },
     {text: '合約狀態', value: 20230 },
     {text: '照護等級', value: 20240 },
     {text: '支付方式', value: 20250 },
     {text: '個案身分類別', value: 20260 },
     {text: '保險身分', value: 30010 },
     {text: '就醫科別', value: 30020 },
     {text: '同療類型', value: 30030 },
     {text: '就診狀態', value: 30040 },
     {text: '申報案類', value: 30050 },
     {text: '處置類型', value: 30060 },
     {text: '調劑類別', value: 30070 },
     {text: '勞職', value: 30080 },
     {text: '給類', value: 30090 },
     {text: '藥品單位', value: 30100 },
     {text: '服法', value: 30110 },
     {text: '診間定義', value: 30120 },
     {text: '病歷狀態', value: 30130 },
     {text: '訪視類型', value: 30140 },
     {text: '掛號來源', value: 30150 },
     {text: '途徑', value: 30160 },
     {text: '醫院', value: 30170 },
     {text: '醫師', value: 30172 },
     {text: '住院原因', value: 30175 },
     {text: '藥物類別', value: 30180 },
     {text: '檢驗類別', value: 30190 },
     {text: '部位', value: 30200 },
     {text: '劑型', value: 30210 },
     {text: '醫令備註', value: 30220 },
     {text: '醫令類別', value: 30230 },
     {text: '中藥處理方式', value: 30300 },
     {text: '中醫-望診', value: 30310 },
     {text: '中醫-問診', value: 30320 },
     {text: '中醫-脈診', value: 30330 },
     {text: '中醫-辨證', value: 30340 },
     {text: '中醫-治則', value: 30350 },
     {text: '中醫-製劑', value: 30360 },
     {text: '遠距會診診間', value: 30410 },
     {text: '復健活動', value: 40010 },
     {text: '日常生活訓練', value: 40020 },
     {text: '活動安排', value: 40030 },
     {text: '清潔記錄', value: 40040 },
     {text: '類型', value: 40050 },
     {text: '其他', value: 40060 },
     {text: '個案營養狀況及現存問題', value: 40070 },
     {text: '營養師評估及建議', value: 40080 },
     {text: '家屬的反應及處理', value: 40090 },
     {text: '護理人員的執行及家屬告知', value: 40100 },
     {text: '主照者評估-睡眠', value: 40110 },
     {text: '主照者評估-情緒', value: 40111 },
     {text: '主照者評估-壓力', value: 40112 },
     {text: '主照者評估-疲憊度', value: 40113 },
     {text: '排便輔助方式-頻率', value: 40120 },
     {text: '活動型態', value: 40130 },
     {text: '行動輔助', value: 40140 },
     {text: '轉介單-服務需求', value: 40150 },
     {text: '轉介單-轉介單位', value: 40160 },
     {text: '轉介單-轉介處置', value: 40170 },
     {text: '共用', value: 50010 },
     {text: '主訴', value: 50020 },
     {text: '理學', value: 50030 },
     {text: '醫囑', value: 50040 },
     {text: '既往病史', value: 50050 },
     {text: '家族病史', value: 50060 },
     {text: '手術病史', value: 50070 },
     {text: '過敏史', value: 50080 },
     {text: '重大傷病史', value: 50090 },
     {text: '傳染病史', value: 50100 },
     {text: '不良產科史', value: 50110 },
     {text: '藥物不良反應', value: 50120 },
     {text: '住院計畫', value: 50130 },
     {text: '入院診斷', value: 50140 },
     {text: '出院治療計畫', value: 50150 },
     {text: '費用科目', value: 60010 },
     {text: '計價來源', value: 60020 },
     {text: '付款方式', value: 60030 },
     {text: '公告類別', value: 70020 },
     {text: '常規類別', value: 70030 },
     {text: '管路更換天數', value: 70040 },
     {text: '藥品單位', value: 80010 },
     {text: '進貨單位', value: 80020 },
     {text: '庫存異動類型', value: 80030 },
     {text: '進貨單位', value: 80040 },
     {text: '庫存調整備註', value: 80050 },
     {text: '病床別', value: 90010 },
     {text: '區域', value: 90020 },
     {text: '房型', value: 90030 },
     {text: '病歷類型', value: 100010 },
     {text: '檢驗結果類型', value: 110010 },
     {text: '檢驗外送單位', value: 110020 },
     {text: '系統公告類型', value: 190110 },
     {text: '系統參數類型', value: 190120 },
     {text: '本地報表類型', value: 190130 },
     {text: '系統取號重複方式', value: 190140 },
    { text: '系統取號規格代碼', value: 190150 },
    { text: '公告分類', value: 190160 }  ];

